/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonSharedUspContractTypeDropdownQueryResponse,
  GetApiV1PersonSharedUspContractTypeDropdown401,
  GetApiV1PersonSharedUspContractTypeDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedUspContractTypeDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonSharedUspContractTypeDropdown } from "../../clients/personSharedController/getApiV1PersonSharedUspContractTypeDropdown.ts";

export const getApiV1PersonSharedUspContractTypeDropdownQueryKey = () =>
  [{ url: "/api/v1/person/shared/usp-contract-type-dropdown" }] as const;

export type GetApiV1PersonSharedUspContractTypeDropdownQueryKey = ReturnType<
  typeof getApiV1PersonSharedUspContractTypeDropdownQueryKey
>;

export function getApiV1PersonSharedUspContractTypeDropdownQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonSharedUspContractTypeDropdownQueryKey();
  return queryOptions<
    GetApiV1PersonSharedUspContractTypeDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedUspContractTypeDropdown401
      | GetApiV1PersonSharedUspContractTypeDropdown500
    >,
    GetApiV1PersonSharedUspContractTypeDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonSharedUspContractTypeDropdown({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todas as opções do enumerador EUspContractType para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de tipos de contrato USP para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/usp-contract-type-dropdown}
 */
export function useGetApiV1PersonSharedUspContractTypeDropdown<
  TData = GetApiV1PersonSharedUspContractTypeDropdownQueryResponse,
  TQueryData = GetApiV1PersonSharedUspContractTypeDropdownQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1PersonSharedUspContractTypeDropdownQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonSharedUspContractTypeDropdownQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonSharedUspContractTypeDropdown401
          | GetApiV1PersonSharedUspContractTypeDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PersonSharedUspContractTypeDropdownQueryKey();

  const query = useQuery(
    {
      ...getApiV1PersonSharedUspContractTypeDropdownQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonSharedUspContractTypeDropdown401
      | GetApiV1PersonSharedUspContractTypeDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
